import i18next from 'i18next';

i18next.addResources('es', 'ErrorScreen', {
  maintenance: 'Sitio en mantenimiento',
  weAreWorking: 'Estamos trabajando para mejorar nuestro servicio.',
  pleaseComeBack: 'Por favor vuelva más tarde.'
});
